import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@mui/material';
import { getColorFromBackground } from 'app/libs/helpers/getColorFromBackground';
import classes from './Flags.module.scss';
export const AssetInfosFlags = ({ asset }) => {
    const flagsRelations = asset.assetFlagsInst;
    return (_jsx("div", { className: "flex row wrap fullWidth", children: flagsRelations === null || flagsRelations === void 0 ? void 0 : flagsRelations.map((flagRelation) => {
            // console.log('flagRelation', flagRelation)
            return (_jsx(Tooltip, { title: `Description: ${flagRelation.flagInst.description || 'No description'}`, children: _jsx("span", { className: classes.item, style: {
                        backgroundColor: flagRelation.flagInst.color,
                        color: getColorFromBackground(flagRelation.flagInst.color),
                    }, children: flagRelation.flagInst.name }) }, flagRelation.flagInst.id));
        }) }));
};
